import { Table } from 'antd';
import styled from 'styled-components';

export const TableStyled = styled(Table)`
  ul.ant-pagination.ant-table-pagination.ant-table-pagination-right {
    margin-bottom: 0;
  }
`;
